<template>
  <v-container fluid grid-list-lg>
    <v-row>
      <v-col cols="4">
        <v-col cols="12">
          <DueDate :service="service.commercial" minDay="5"> </DueDate>
        </v-col>
        <v-col cols="12">
          <CommercialStatus> </CommercialStatus>
        </v-col>
      </v-col>
      <v-col cols="8">
        <CommercialList> </CommercialList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CommercialStatus from "../../AdImage/components/Status";
import CommercialList from "../../AdImage/components/Commercial/CommercialList";
import DueDate from "./components/DueDate";
// import CommentList from '../../Comment/components/List'
import { mapGetters } from "vuex";
export default {
  components: {
    CommercialStatus,
    CommercialList,
    // CommentList,
    DueDate
  },
  computed: {
    ...mapGetters("location", ["location", "service"]),
    ...mapGetters("global", ["currentUser"]),
    dueDateCount() {
      return this.$moment(this.service.commercial.dueDate).diff(
        this.$moment().format("MM/DD/YYYY"),
        "day"
      );
    }
  },
  methods: {
    updateNote() {
      ReconcileService.update(this.service.commercial.storeID, 193, this.service.reconcile)
        .then(result => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "success",
              title: "Reconcile Service is started"
            });
          this.$emit("updated");
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped></style>
